import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { toSlug } from "../../../shared/utils";
import { GerarMovimentacaoObraFormData } from "../schema/gerar-movimentacao-obra.schema";
import { CancelarMovimentacaoObraContract } from "../contracts/cancelar-movimentacao-obra.contract";


const gerar = async (data: GerarMovimentacaoObraFormData): Promise<void> => {
    try {
        await baseApiService.post('/construction-movement', data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const cancelar = async (id: string, data: CancelarMovimentacaoObraContract): Promise<void> => {
    try {
        await baseApiService.put(`/construction-movement/${id}`, data);
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/construction-movement/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (idWork: string) => {
    try {
        const response = await baseApiService.get(`/construction-movement/find-all/${idWork}`);
        return response.data.data;
    } catch (error) {
        throw errosHandler(error);
    }
};



export const movimentacaoObraService = {
    gerar,
    findAll,
    cancelar,
    detalhar
};

